export enum EventTypeEnum {
  PAGE_VIEW = 'PAGE_VIEW',
  USER_ACTION = 'USER_ACTION',
  HTTP_REQUEST = 'HTTP_REQUEST',
  SESSION_END = 'SESSION_END',
  SESSION_START = 'SESSION_START',
}
